import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapActions } from 'vuex';
import { register } from '@/api/user';
export default {
  name: 'Register',
  data: function data() {
    var _this = this;
    var ratioPassword = function ratioPassword(rule, value, callback) {
      if (value != _this.registerForm.password) {
        return callback(new Error('两次密码不同'));
      } else {
        callback();
      }
    };
    var checkUsername = function checkUsername(rule, value, callback) {
      if (value.length < 5 || value.length > 12) {
        return callback(new Error('请输入正确的用户名'));
      } else {
        callback();
      }
    };
    var checkPassword = function checkPassword(rule, value, callback) {
      if (value.length < 6 || value.length > 12) {
        return callback(new Error('请输入正确的密码'));
      } else {
        callback();
      }
    };
    return {
      lock: 'lock',
      registerForm: {
        username: '',
        password: '',
        rePassword: ''
      },
      rules: {
        username: [{
          validator: checkUsername,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          trigger: 'blur'
        }],
        rePassword: [{
          validator: ratioPassword,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['LoginIn'])), {}, {
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs.registerForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(v) {
                  var res;
                  return regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!v) {
                          _context.next = 2;
                          break;
                        }
                        _context.next = 1;
                        return register(_this2.registerForm);
                      case 1:
                        res = _context.sent;
                        if (res.code == 0) {
                          _this2.$message({
                            type: 'success',
                            message: '注册成功',
                            showClose: true
                          });
                          _this2.$router.push({
                            name: "login"
                          });
                        }
                        _context.next = 3;
                        break;
                      case 2:
                        _this2.$message({
                          type: 'error',
                          message: '请正确填写注册信息',
                          showClose: true
                        });
                        return _context.abrupt("return", false);
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    changeLock: function changeLock() {
      this.lock === 'lock' ? this.lock = 'unlock' : this.lock = 'lock';
    }
  })
};